import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('about');

    const navLinks = [
        { id: 'about', label: 'About' },
        { id: 'products', label: 'Products' },
        { id: 'membership', label: 'Membership' },
        { id: 'branches', label: 'Branches' },
        { id: 'legal', label: 'Legal' },
        { id: 'contact', label: 'Contact' },
    ];

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);

            const sections = navLinks.map(link => link.id);
            const current = sections.find(section => {
                const element = document.getElementById(section);
                if (element) {
                    const rect = element.getBoundingClientRect();
                    return rect.top <= 150 && rect.bottom >= 150;
                }
                return false;
            });

            if (current) {
                setActiveSection(current);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            const offset = 80;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
        setIsMobileMenuOpen(false);
    };

    return (
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white'
            }`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center py-4">
                    <div className="flex items-center space-x-3">
                        <div>
                            <img
                                src='./logo.png'
                                className='w-12 h-12'
                            />
                        </div>
                        <div>
                            <h1 className="text-lg font-bold text-gray-800">Sagwara Mahila Bachat Samiti</h1>
                            <p className="text-xs text-gray-600">Sagwara Apni Bachat Ghar Mahila Sahakari Samiti Limited.</p>
                        </div>
                    </div>

                    <div className="hidden md:flex items-center space-x-1">
                        {navLinks.map((link) => (
                            <button
                                key={link.id}
                                onClick={() => scrollToSection(link.id)}
                                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${activeSection === link.id
                                    ? 'bg-amber-900 text-white'
                                    : 'text-amber-900 hover:bg-amber-50 hover:text-amber-700'
                                    }`}
                            >
                                {link.label}
                            </button>
                        ))}
                    </div>

                    <button
                        className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>

                {isMobileMenuOpen && (
                    <div className="md:hidden pb-4">
                        <div className="flex flex-col space-y-2">
                            {navLinks.map((link) => (
                                <button
                                    key={link.id}
                                    onClick={() => scrollToSection(link.id)}
                                    className={`px-4 py-2 rounded-md text-sm font-medium text-left transition-colors ${activeSection === link.id
                                        ? 'bg-amber-900 text-white'
                                        : 'text-amber-950 hover:bg-amber-50 hover:text-amber-900'
                                        }`}
                                >
                                    {link.label}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            <div className="bg-amber-900 text-white text-center py-1 px-4">
                <p className="text-xs sm:text-sm font-medium">Member-owned ● Community-focused</p>
            </div>
        </nav>
    );
};

export default Navbar;
